import type { ReactNode } from "react";
import type { WorkUnitSummary } from "@/api/adminWorkUnit";
import { formatWorkUnitProgress } from "./workUnitFormat";
import styles from "./WorkUnitProgressCell.module.css";

// 작업 큐 목록의 진행 셀이다. 첫 줄은 에피소드 진행이다. 둘째 줄은 작업 단위 진행이다.
export function WorkUnitProgressCell({
  primary,
  units,
}: {
  primary: string;
  units: WorkUnitSummary;
}): ReactNode {
  const secondary = formatWorkUnitProgress(units);
  return (
    <span className={styles.cell}>
      <span>{primary}</span>
      {secondary !== null && <span className={styles.secondary}>{secondary}</span>}
    </span>
  );
}
